import React from 'react';
import {
    Container,
    Typography,
    Paper,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box
} from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { motion } from 'framer-motion';
import '../styles/LegalPages.scss';

const FAQ = () => {
    const faqs = [
        {
            question: "Milyen típusú projekteket vállalnak?",
            answer: "Cégünk széles körű építőipari szolgáltatásokat nyújt, beleértve az ipari létesítmények kivitelezését, kereskedelmi ingatlanok építését, toronyépítést, felújítási munkálatokat és infrastrukturális fejlesztéseket. Minden projektet egyedi igények szerint, professzionális kivitelezéssel valósítunk meg."
        },
        {
            question: "Mennyi időt vesz igénybe egy projekt megvalósítása?",
            answer: "A projekt időtartama nagyban függ annak méretétől és komplexitásától. Egy kisebb felújítás néhány hét alatt elkészülhet, míg egy nagyobb ipari létesítmény kivitelezése több hónapot is igénybe vehet. A pontos időtartamot az egyeztetések során, a részletes tervek ismeretében tudjuk meghatározni."
        },
        {
            question: "Milyen garanciát vállalnak a kivitelezésre?",
            answer: "Munkáinkra a jogszabályban előírt kötelező jótállási időn felül, típustól függően további garanciát vállalunk. A pontos garanciális feltételeket a szerződésben rögzítjük. Cégünk rendelkezik a szükséges felelősségbiztosításokkal is."
        },
        {
            question: "Hogyan történik az árajánlat készítése?",
            answer: "Az árajánlat készítése során figyelembe vesszük a projekt minden részletét. Helyszíni felmérést követően részletes, tételes árajánlatot készítünk, amely tartalmazza az anyagköltséget, munkadíjat és minden egyéb kapcsolódó költséget. Az árajánlat elkészítése általában díjmentes."
        },
        {
            question: "Milyen referenciákkal rendelkeznek?",
            answer: "Több mint 10 éves tapasztalattal rendelkezünk az építőiparban. Referenciáink között szerepelnek jelentős ipari létesítmények, kereskedelmi épületek és infrastrukturális projektek. Konkrét referenciáinkat megtekintheti weboldalunk Projektek menüpontjában."
        },
        {
            question: "Vállalnak-e kisebb projekteket is?",
            answer: "Igen, kisebb projekteket is vállalunk, amennyiben azok illeszkednek szakmai profilunkba. Minden megkeresést egyedileg értékelünk és az ügyfél igényeinek megfelelő megoldást kínálunk."
        },
        {
            question: "Hogyan zajlik a projekt kivitelezése?",
            answer: "A projekt kivitelezése több lépésben történik: először részletes tervezés és ütemezés készül, majd a szükséges engedélyek beszerzése után kezdődik a kivitelezés. A munka során folyamatos kapcsolatban állunk a megrendelővel, rendszeres projekt státusz jelentésekkel és helyszíni egyeztetésekkel."
        },
        {
            question: "Milyen fizetési feltételeket biztosítanak?",
            answer: "A fizetési feltételeket projekt specifikusan határozzuk meg. Általában a szerződéskötéskor előleget kérünk, majd a kivitelezés során részteljesítések alapján történik a számlázás. A végső elszámolás a projekt átadás-átvételét követően történik."
        },
        {
            question: "Rendelkeznek-e a szükséges engedélyekkel és minősítésekkel?",
            answer: "Igen, cégünk rendelkezik minden szükséges működési és szakmai engedéllyel, valamint minősítéssel. Munkatársaink szakképzettek és rendszeresen részt vesznek továbbképzéseken a legújabb technológiák és módszerek elsajátítása érdekében."
        },
        {
            question: "Mi történik, ha probléma merül fel a kivitelezés során?",
            answer: "Ha bármilyen probléma merül fel a kivitelezés során, azonnal reagálunk és megoldjuk azt. Projektvezetőink 24 órában elérhetőek sürgős esetekben. Minden projekthez részletes kockázatkezelési tervet készítünk, hogy minimalizáljuk a váratlan események hatását."
        }
    ];

    return (
        <div className="legal-page faq-page">
            <motion.div
                className="page-header"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
            >
                <div className="header-background" />
                <Container>
                    <motion.div
                        initial={{ y: -30, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.8 }}
                        className="header-content"
                    >
                        <Typography variant="h1">Gyakran Ismételt Kérdések</Typography>
                        <Typography variant="subtitle1">
                            Válaszok a leggyakrabban felmerülő kérdésekre
                        </Typography>
                    </motion.div>
                </Container>
            </motion.div>

            <Container>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.6 }}
                >
                    <Paper elevation={3} sx={{ p: 4, mt: -8, mb: 6, borderRadius: 2 }}>
                        <Box mb={4}>
                            <Typography variant="body1" paragraph>
                                Az alábbiakban összegyűjtöttük a leggyakrabban felmerülő kérdéseket és válaszokat.
                                Ha nem találja a választ kérdésére, keressen minket bizalommal elérhetőségeinken.
                            </Typography>
                        </Box>

                        {faqs.map((faq, index) => (
                            <Accordion
                                key={index}
                                sx={{
                                    mb: 1,
                                    '&:before': { display: 'none' },
                                    background: 'transparent',
                                    boxShadow: 'none',
                                    border: '1px solid rgba(0, 0, 0, 0.1)',
                                    borderRadius: '8px !important',
                                    overflow: 'hidden',
                                    '&.Mui-expanded': {
                                        margin: '0 0 8px 0',
                                    }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    sx={{
                                        background: 'rgba(44, 80, 73, 0.02)',
                                        '&:hover': {
                                            background: 'rgba(44, 80, 73, 0.05)',
                                        }
                                    }}
                                >
                                    <Typography
                                        variant="h6"
                                        sx={{
                                            fontSize: '1.1rem',
                                            fontWeight: 600,
                                            color: '#2c5049'
                                        }}
                                    >
                                        {faq.question}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            color: '#555',
                                            lineHeight: 1.7
                                        }}
                                    >
                                        {faq.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Paper>
                </motion.div>
            </Container>
        </div>
    );
};

export default FAQ; 